import type { AxiosRequestConfig } from 'axios';

/**
 * `axiosPrivate` sets a default `Content-Type: application/json`. axios 0.x keeps that
 * header for `FormData` bodies, so the browser never adds the `multipart/form-data`
 * boundary and the upload fails server-side. Passing this config to a multipart request
 * strips `Content-Type` (top level + per-method buckets) so the browser sets it itself.
 */
export const multipartFormDataConfig: AxiosRequestConfig = {
  transformRequest: [
    (data: unknown, headers?: Record<string, unknown>): unknown => {
      if (headers) {
        delete headers['Content-Type'];
        ['common', 'post', 'put', 'patch'].forEach((bucket) => {
          const bucketHeaders = headers[bucket];
          if (bucketHeaders && typeof bucketHeaders === 'object') {
            delete (bucketHeaders as Record<string, string>)['Content-Type'];
          }
        });
      }
      return data;
    },
  ],
};
